export const passwordUndefinedError = "Please input a password."

export const passwordInsecureError = "Please enter a more secure password."

export const passwordMismatchError = "The passwords you enter must match."

export const acceptTermsError = "Please accept the Terms and Conditions to continue."

export const personaError = "Please choose a Quorum product."

export const formSubmitError =
    "Sorry! There was a problem activating your account. Please contact Support to resolve this issue."

export const formTextPasswordAndPersonas =
    "We’re excited to help you work smarter and move faster with tools to map, track, change, and report on your entire policy landscape. To get started, set your password and choose what you’re most focused on so we can customize your Quorum experience."

export const formTextPasswordOnly =
    "We’re excited to help you work smarter and move faster with tools to map, track, change, and report on your entire policy landscape. To get started, set your password."

export const formTextPersonasOnly =
    "We’re excited to help you work smarter and move faster with tools to map, track, change, and report on your entire policy landscape. To get started, choose what you’re most focused on so we can customize your Quorum experience."

export const formTextDefault =
    "We’re excited to help you work smarter and move faster with tools to map, track, change, and report on your entire policy landscape."

// 0 # too guessable: risky password. (guesses < 10^3)
// 1 # very guessable: protection from throttled online attacks. (guesses < 10^6)
// 2 # somewhat guessable: protection from unthrottled online attacks. (guesses < 10^8)
// 3 # safely unguessable: moderate protection from offline slow-hash scenario. (guesses < 10^10)
// 4 # very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)
export const passwordStrengthThreshold = 2
